//-------------------------------------------------------------------------------------------------- Imports
import { StyleSheet } from "../StyleSheet";
import { images } from "../routes/ImageRoutes";

//-------------------------------------------------------------------------------------------------- Interfaces
interface InstallAppModalProps {
    show?: boolean;
};

//-------------------------------------------------------------------------------------------------- Component
const InstallAppModal = (props: InstallAppModalProps) => {
    const { show } = props;

    return ((show) ? (
        <div style={styles.mainContainer} >
            <div style={styles.modalContainer}>
                <div style={styles.container}>
                    <img style={styles.imageMega} src={images.logoMega2} alt="Logo megacable" />
                </div>
                <div style={styles.imageContainer}>
                    <img style={styles.imageDownloadInMovil} src={images.downloadApp} alt="Descarga en móvil"/>
                    <h2 style={styles.text1}>¡Cámbiate a móvil!</h2>
                    Para una mejor experiencia en esta resolución, lo invitamos a descargar la Megacable App.
                    <p>Disponible en Android & iOS</p>
                </div>
                <div style={styles.container}>
                    <div style={styles.storesContainer} onClick={() => window.open("https://play.google.com/store/apps/details?id=mx.com.megacable", "_blank")}>
                        <img style={styles.imageStores} src={images.googlePlay} alt="Descarga en Google Play" />
                    </div>
                    <div style={styles.storesContainer} onClick={() => window.open("https://apps.apple.com/us/app/megacable-app/id1466002118?ign-itsct=apps_box&ign-itscg=30200", "_blank")}>
                        <img style={styles.imageStores} src={images.appStore} alt="Descarga en App Store" />
                    </div>
                </div>
            </div>
        </div>
    ) : (
        null
    ));
};

//-------------------------------------------------------------------------------------------------- 
const styles = StyleSheet.create({
    mainContainer: {
        display: "flex",
        position: "absolute",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 20,
    },
    modalContainer: {
        display: "flex",
        width: 400,
        height: 600,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 20,
        flexDirection: "column",
        backgroundColor: "#ffffff",
        backgroundImage: `url("${images.backgroundChangeToMovil}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "130% 100%",
        backgroundPosition: "center",
    },
    imageContainer: {
        flex: 1,
        display: "flex",
        width: "100%",
        padding: "0px 50px 0px 50px",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        color: "#ffffff",
    },
    imageDownloadInMovil: {
        height: 180,
    },
    text1: {
        color: "#46f2ff",
        fontWeight: 600,
    },
    container: {
        display: "flex",
        width: "100%",
        height: 120,
        alignItems: "center",
        justifyContent: "center",
    },
    storesContainer: {
        display: "flex",
        width: "45%",
        height: "100%",
        alignItems: "flex-start",
        paddingTop: 20,
        justifyContent: "center",
    },
    imageMega: {
        height: 50,
    },
    imageStores: {
        cursor: "pointer",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default InstallAppModal;
